import React, { useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { Button, Stack } from '@mui/material'
import Editor from 'components/editor'
const EditModal = ({ data, handleRefresh }) => {
  console.log(data, 'data')
  const AppService = useAppServices()
  const [openEditProduct, setOpenEditProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const uploadImage = useUploadImage()
  const [description, setDescription] = useState(data.description)
  const [awardDescription, setAwardDescription] = useState(data.award_description)
  const handleModal = () => {
    setOpenEditProduct(true)
  }

  const closeEditProduct = () => {
    setOpenEditProduct(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)
    let image_response = data.image
    if (e.target?.image?.files?.[0]) {
      const { response } = await uploadImage({
        file: e.target?.image?.files?.[0],
        desiredPath: `app/logo/image`,
      })
      if (response) {
        image_response = response.data
      }
    }

    const payload = {
      name: e.target.name.value,
      award_name: e.target.award_name.value,
      // award_description: e.target.award_description.value,
      award_description: awardDescription,
      description: description,
      status: e.target.status.value,
      // description: e.target.description.value,
      points: e.target.points.value,
      image: image_response,
    }

    console.log(payload, 'payload')

    const { response } = await AppService.onboardlistcategory.update({
      query: `_id=${data._id}`,
      payload,
    })

    if (response) {
      setProcessing(false)
      setOpenEditProduct(false)
      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={style}
            encType="multipart/form-data"
          >
            <MDTypography variant="h5" mb={2}>
              Edit Category
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required defaultValue={data.name} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Award Name</MDTypography>
              <MDInput
                label="Award Name"
                name="award_name"
                fullWidth
                defaultValue={data.award_name}
              />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Award Description</MDTypography>
              <Editor handleChange={setAwardDescription} data={awardDescription} />
            </MDBox>
            <MDBox mb={2}>
              <MDBox mb={2}>
                <MDTypography variant="button">Description</MDTypography>
                <Editor handleChange={setDescription} data={description} />
              </MDBox>

            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Status</MDTypography>
              <MDInput
                select
                name="status"
                fullWidth
                required
                SelectProps={{ native: true }}
                defaultValue={data.status}
              >
                <option value="Publish">Publish</option>
                <option value="Draft">Draft</option>
              </MDInput>
            </MDBox>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Image +
                <input hidden name="image" type="file" />
              </Button>
            </Stack>

            <MDBox mb={2}>
              <MDTypography variant="button">Point Number</MDTypography>
              <MDInput label="Point Number" name="points" fullWidth defaultValue={data.points} />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditModal
